import styled from 'styled-components'
import { media, colors } from 'shared/lib'
import { Panel } from 'shared/components/Panel'

const AccountPagePanel = styled(Panel)`
  margin: 15px 0;
  border: 1px solid ${colors.FC2_LIGHTEST_GREY};
  ${media.large`
    margin: 0 0 20px;
    min-height: 180px;
    flex-basis: calc(50% - 10px);
  `}
`

export default AccountPagePanel
